import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
import './index.css';
import DataQualityWidget from './DataQualityWidget';


// Declarar tipos globais para o serviço de comunicação
declare global {
    interface Window {
        webComponentCommunication?: {
            receiveDataFromWebComponent: (data: any) => void;
            data$: any;
        };
    }
}

const DataQualityWebComponent = r2wc(DataQualityWidget, {
    props: { apiResponse: {} as any }
});

// Registrar o Web Component no navegador
if (!customElements.get('data-quality-sop')) {
    customElements.define('data-quality-sop', DataQualityWebComponent);
}

export default DataQualityWebComponent;